import { Link } from "react-router-dom";

interface ArticleHeroProps {
  title: string;
  category: string;
  categorySlug: string;
  date: string;
  views: string;
  comments: string;
  shares: string;
  heroImageUrl: string;
}

export default function ArticleHero({
  title,
  category,
  categorySlug,
  date,
  views,
  comments,
  shares,
  heroImageUrl,
}: ArticleHeroProps) {
  return (
    <section className="relative w-full h-[400px] md:h-[550px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${heroImageUrl})` }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/80"></div>

      <div className="relative z-10 w-full px-4 md:px-6 mt-16">
        <div className="max-w-4xl mx-auto">
          <Link
            to={`/category/${categorySlug}`}
            className="inline-flex items-center gap-1.5 text-sm text-primary-400 hover:text-primary-300 transition-colors duration-200 mb-4"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line"></i>
            </span>
            {category}
          </Link>

          <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-50 leading-tight mb-4">
            {title}
          </h1>

          <div className="flex flex-wrap items-center gap-3 md:gap-5 text-xs md:text-sm text-foreground-400">
            <span className="flex items-center gap-1">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-calendar-line"></i>
              </span>
              {date}
            </span>
            <span className="flex items-center gap-1">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-eye-line"></i>
              </span>
              {views}
            </span>
            <span className="flex items-center gap-1">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-chat-1-line"></i>
              </span>
              {comments}
            </span>
            <span className="flex items-center gap-1">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-share-forward-line"></i>
              </span>
              {shares}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}